module.exports = __webpack_public_path__ + "static/media/change-password.cdfecef9.svg";